import { useContext } from "react";
import { buildLink } from "common/routing";
import { buildGuestPropertyURL } from "common/utils/url";
import { GetDocumentUploadsQuery } from "../../../generated/graphql";
import { getDocumentUploadUrl } from "../../../utils/documentUploads";
import { track } from "../../../utils/tracking";
import { AuthContext } from "../../Authorization/AuthContext";
import DropdownMenu, { ActionsProps } from "../../Inputs/DropdownMenu";
export interface Props {
  documentUpload: GetDocumentUploadsQuery["documentUploads"]["data"][number];
}

const ActionButton = ({ documentUpload }: Props) => {
  const account = useContext(AuthContext).account!;

  const property = documentUpload.property;

  if (!property) return null;

  const downloadName = property.fullAddress
    ? property.fullAddress.replace(/,?[ ]/g, "-")
    : `property-${property.id}`;

  const download = `${downloadName}-EC.pdf`;

  const actions: Array<ActionsProps> = [
    {
      label: "View File",
      href: getDocumentUploadUrl({
        id: documentUpload.id,
        externalDocumentURL: documentUpload.externalDocumentURL ?? null,
        isPublic: true,
        intendedRoute: "guestDocumentUploadFile",
      }),
      target: "_blank",
    },
    ...(documentUpload.externalDocumentURL
      ? []
      : [
          {
            label: "Download PDF",
            href: buildLink(
              "documentUploadFile",
              { id: documentUpload.id },
              { accountId: account.id },
            ),
            download: download,
            target: "_blank",
            track: () =>
              track("PPP EC Downloaded", {
                documentUploadId: documentUpload.id,
                propertyId: property.id,
                streetAddress: property.fullAddress,
                documentTypeName: documentUpload.accountDocumentType.name,
              }),
          },
        ]),
    {
      label: "Go to Property Profile",
      href: buildGuestPropertyURL({
        subdomain: account.subdomain,
        propertyId: property.id,
      }),
    },
  ];

  return <DropdownMenu actions={actions} />;
};

export default ActionButton;
